import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
// import "./Doorscanner";
// import logo from "../assets/img/Vector.png";
// import footerLogo from "../assets/img/Group.png";
// import loginImg from "../assets/img/loginImage.jpg";
import logowhite from "../assets/img/Full logo blue.png";
import containertext from "../assets/img/Container.png";
import emaillogo from "../assets/img/email.png";
import backgroundImg from "../assets/img/bg-img.png";
import { loginUser } from "../store/slices/UserSlice";
// import DoorScanner from "../doorscanner";
import { clearUser } from "../store/slices/UserSlice";
import http from "../api/server";
import { GET_USER_CLIENT } from "../api/apiPath";
import { Link } from "react-router-dom";

import Toaster from "./common/Toaster";
import { useRef, useCallback, useMemo } from "react";
const LogIn = () => {
  const [step, setStep] = useState("login"); // checkEmail | resetPassword | login
  // const [strength, setStrength] = useState("");
  // const [strengthColor, setStrengthColor] = useState("black");
  const [userEmail, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [counter, setCounter] = useState(30);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [inputError, setInputError] = useState("");
  const [clientData, setClientData] = useState(null);

  const inputRefs = useRef([]);
  const defaultOTPObj = {
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: "",
  };
  useEffect(() => {
    inputRefs.current[0]?.focus(); // Focus on the first input on component mount
  }, []);
  const [otpValues, setOtpValues] = useState(defaultOTPObj);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  // dispatch and navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientName } = useParams();

  useEffect(() => {
    dispatch(clearUser());
  }, [dispatch]);

    useEffect(() => {
    const savedEmail = sessionStorage.getItem("userEmail");
    if (savedEmail) {
      setEmail(savedEmail); // your state setter
      sessionStorage.removeItem("userEmail");
      setStep("login");
    }
  }, []);
  useEffect(() => {
    let timer;
    if (isResendDisabled && counter > 0) {
      timer = setInterval(() => {
        setCounter((prev) => prev - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter, isResendDisabled]);

  //Get Client list associated with the email
  useEffect(() => {
    const fetchClients = async () => {
      const payload = { userEmail: userEmail };

      try {
        const response = await http.get(GET_USER_CLIENT, {
          params: payload,
        });

        console.log("Client data:", response.data);
        setClientData(response.data);
      } catch (error) {
        console.error(
          "Error fetching clients:",
          error.response?.data || error.message
        );
      }
    };

    if (step === "getUserClients") {
      fetchClients();
    }
  }, [step, userEmail]);

  const handleResend = () => {
    // Trigger resend OTP logic here
    console.log("Resending OTP...");
    setCounter(30);
    setIsResendDisabled(true);
    if (clientName) {
      sendOTP();
      setOtpValues(defaultOTPObj);
    } else {
      setStep("getUserClients");
    }
  };

  // Simulated API call for password reset
  // Real API call for password reset
  const resetPasswordAPI = async (email) => {
    try {
      const response = await http.get(
        "/api/Auth/AnonymousUser-OTP?userEmail=" + email
      );
      return response;
    } catch (error) {
      return error;
    }
  };

  // const verifyOTP = async () => {
  //   const otpString = Object.values(otpValues).join("");
  //   try {
  //     const response = await http.post("api/Auth/validate-otp", {
  //       email,
  //       otp: otpString
  //     });
  //     return response;
  //   } catch (error) {
  //     return error;
  //   }
  // };

  //
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoginError("");
    const otpString = Object.values(otpValues).join("");
    dispatch(loginUser({ userEmail, otp: otpString })).then((response) => {
      if (
        response?.error?.message ||
        response?.error?.message == "Invalid OTP." ||
        response?.error?.message == "OTP is expired. Please re-generate OTP." ||
        response?.error?.message ==
          "OTP is already used. Please re-generate OTP."
      ) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response?.error?.message,
        });
        setOtpValues(defaultOTPObj);
        setLoginError(response?.error?.message);
        console.log(loginError);
        setStep("login");
      } else {
        resetValue();
        // if (response?.payload?.data) {
        //   navigate("/resident-form");
        // }
        if (response?.payload?.data) {
          const redirectUrl = sessionStorage.getItem("redirectAfterLogin");
          if (redirectUrl) {
            sessionStorage.removeItem("redirectAfterLogin");
            navigate(redirectUrl);
          } else if (clientName) {
            navigate(
              generatePath("/client/:clientName/resident-form", { clientName })
            );
          } else {
            navigate("/client");
          }
        }
      }
    });

    setLoading(false);
  };

  const sendOTP = async () => {
    if (!isValidEmailOrMobile(userEmail)) {
      setInputError("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    const response = await resetPasswordAPI(userEmail, password);
    if (response.status !== 400) {
      setStep("enter otp");
      setLoading(false);
    } else {
      setLoginError(response?.response?.data?.message);
      setLoading(false);
    }
  };

  const [validate, setValidate] = useState({
    hasLow: false,
    hasCap: false,
    hasNumber: false,
    has8digit: false,
  });
  const strengthNew = Object.values(validate).reduce((a, item) => a + item, 0);

  const feedback = {
    1: "Password is to weak!",
    2: "It's still weak! ",
    3: "You almost there!",
    4: "Great!! now your password is strong",
  }[strengthNew];

  useEffect(() => {
    if (!password && !confirmPassword) return;
  }, [password, confirmPassword, feedback]);

  const resetValue = () => {
    setEmail("");
    setConfirmPassword("");
    setLoading(false);
    setPassword("");
    setLoginError("");
    setValidate({
      hasLow: false,
      hasCap: false,
      hasNumber: false,
      has8digit: false,
    });
    setOtpValues(defaultOTPObj);
  };

  const setOTPValue = (value, digitKey, index) => {
    setOtpValues((prevOtpValues) => ({
      ...prevOtpValues,
      [digitKey]: value.substring(value.length - 1), // Take only the last character entered
    }));
    // Auto-focus the next input field if a digit is entered and it's not the last field
    if (value.length === 1 && index !== 5) {
      inputRefs.current[index + 1].focus();
    }
  };
  const handleCloseToaster = useCallback(() => {
    setToastData({
      toastShow: false,
      toastString: "",
      toastType: "",
    });
    setOtpValues(defaultOTPObj);
  }, []);

  const toasterProps = useMemo(
    () => ({
      show: toastData.toastShow,
      toastType: toastData.toastType,
      title: toastData.toastString,
      theme: "dark",
      position: "top-center",
      closeButton: handleCloseToaster,
    }),
    [
      toastData.toastShow,
      toastData.toastType,
      toastData.toastString,
      handleCloseToaster,
    ]
  );

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && e.target.value === "") {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (pastedData.length === 6 && /^\d+$/.test(pastedData)) {
      const optArray = pastedData.split("");

      const defaultOTPObj = {
        digit1: optArray[0],
        digit2: optArray[1],
        digit3: optArray[2],
        digit4: optArray[3],
        digit5: optArray[4],
        digit6: optArray[5],
      };

      setOtpValues(defaultOTPObj);
      // Optionally focus the last input after pasting
      inputRefs.current[5]?.focus();
    }
  };

  const handleEmail = (e) => {
    setLoginError("");
    setEmail(e.target.value);
    setInputError("");
  };

  const isValidEmailOrMobile = (value) => {
    // Email regex
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //.com or .in    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const additionalemailRegex = /^[^\s@]+@[^\s@]+\.(com|in|co\.in|co\.uk)$/;
    // General mobile regex: optional +, 8-15 digits
    // const mobileRegex = /^\+?\d{8,15}$/;
    // const valid1 = emailRegex.test(value);
    // const valid2 = mobileRegex.test(value);
    const valid3 = additionalemailRegex.test(value);
    return valid3;
  };

  return (
    <div
      className="main_body"
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "leftBottom",
        backgroundSize: "contain",
        width: "100%",
        height: "100vh",
      }}
    >
      <div className="logopg">
        <img src={logowhite} className="login-page-logo" alt="logo" />
      </div>
      <div>
        <img
          src={containertext}
          className="login-page-containertext"
          alt="logo"
        />
      </div>
      <Toaster {...toasterProps} />
      {step === "enter otp" && (
        <>
          <div className="login-container d-flex justify-content-center">
            <div className="card login-card align-items-center">
              <div className="d-flex w-100 flex-column text-start mb-3">
                <div className="col-sm-12 text-start">
                  <h3 className="fw-bold white-text mb-0 veryfyotp ">Verify OTP</h3>
                </div>

                <div className="col-sm-12">
                  <p className="text text-start mt-2">
                    Enter the 6-digit code sent to{" "}
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      {userEmail}
                    </span>
                    . This OTP is valid for 10 minutes only.
                    {/* <p className="text">The code is valid for 10 minutes.</p> */}
                  </p>
                </div>
                <div className="d-flex w-100 mt-3 flex-column align-items-center gap-2">
                  <form className="w-100 mt-3">
                    <div className="col-sm-12 mb-3 d-flex gap-3 justify-content-evenly">
                      <input
                        type="password"
                        className="form-control-box1"
                        maxLength="1"
                        value={otpValues.digit1}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit1", 0);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                        ref={(el) => (inputRefs.current[0] = el)}
                        onPaste={handlePaste}
                      />
                      <input
                        type="password"
                        className="form-control-box2"
                        maxLength="1"
                        value={otpValues.digit2}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit2", 1);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 1)}
                        ref={(el) => (inputRefs.current[1] = el)}
                      />
                      <input
                        type="password"
                        className="form-control-box3"
                        maxLength="1"
                        value={otpValues.digit3}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit3", 2);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 2)}
                        ref={(el) => (inputRefs.current[2] = el)}
                      />
                      <input
                        type="password"
                        className="form-control-box4"
                        maxLength="1"
                        value={otpValues.digit4}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit4", 3);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 3)}
                        ref={(el) => (inputRefs.current[3] = el)}
                      />
                      <input
                        type="password"
                        className="form-control-box5"
                        maxLength="1"
                        value={otpValues.digit5}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit5", 4);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 4)}
                        ref={(el) => (inputRefs.current[4] = el)}
                      />
                      <input
                        type="password"
                        className="form-control-box6"
                        maxLength="1"
                        value={otpValues.digit6}
                        onChange={(e) => {
                          setOTPValue(e.target.value, "digit6", 5);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 5)}
                        ref={(el) => (inputRefs.current[5] = el)}
                      />
                    </div>

                    <div className="col-sm-12 mb-4 text-center">
                      <span
                        className={
                          isResendDisabled ? "resend-disabled" : "resend"
                        }
                        onClick={isResendDisabled ? null : handleResend}
                      >
                        {isResendDisabled
                          ? `Resend OTP in ${counter}s`
                          : "Resend OTP"}
                      </span>
                      <button
                        type="submit"
                        disabled={
                          loading ||
                          Object.values(otpValues).some((val) => val === "")
                        }
                        className="btn btn-secondary mt-3 w-100"
                        style={{ fontWeight: "bold" }}
                        onClick={(e) => handleVerifyOTP(e)}
                      >
                        {loading ? "Please wait..." : "Verify OTP"}
                      </button>
                    </div>

                    {/* <div className=" px-5 py-0 w-100">
                  <div className="col-sm-12 mb-2">
                    
                  </div>
                </div> */}
                    <div className="col-12 d-flex justify-content-center mt-5">
                      <button
                        type="submit"
                        className="btn-back mb-3 w-100"
                        onClick={() => {
                          setStep("login");
                          resetValue();
                        }}
                      >
                        <div className="text-black text-end ">
                          <i className="fa fa-arrow-left mt-1 me-2 "></i> Back
                          to Login
                        </div>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="terms-conditions">
                <p className="mb-0">
                  BY CONTINUING, YOU AGREE TO OUR{" "}
                  <Link
                    to="/PrivacyPolicy"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    TERMS OF SERVICE
                  </Link>{" "}
                  AND{" "}
                  <Link
                    to="/PrivacyPolicy"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    PRIVACY POLICY
                  </Link>
                  <p className="mt-4">COPYRIGHT@2025, FIRE INSPECT</p>
                </p>
              </div>
            </div>
          </div>
        </>
      )}
      {step === "login" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card px-5 pt-5 pb-4 align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className=" login-card-text fw-bold white-text veryfyotp">Resident Management System</h3>
              <p className=" login-card-text text">
                Enter your email address to continue
              </p>
            </div>
            <div className=" d-flex w-100 mt-3 flex-column align-items-center gap-2">
              <form className="w-100">
                <div className="col-sm-12 mb-3 mobtop">
                  <div className="form-floating">
                    <p className="logtext text-start">Email Address</p>
                    <input
                      type="email"
                      className="form-controlinputbox ps-5"
                      id="floatingInput"
                      onChange={(e) => handleEmail(e)}
                     value={userEmail}
                    />
                    <img
                      src={emaillogo}
                      className="input-icon mt-1"
                      alt="logo"
                    />
                  </div>
                </div>
                {inputError && (
                  <div
                    style={{
                      color: "red",
                      marginTop: "-15px",
                      marginBottom: "10px",
                      fontSize: "0.95em",
                    }}
                  >
                    {inputError}
                  </div>
                )}

                <div className="col-sm-12">
                  <button
                    type="submit"
                    className="btn btn-secondary mb-3 w-100"
                    style={{ fontWeight: "bold" }}
                    disabled={loading || userEmail.length === 0}
                    onClick={() => {
                      // sendOTP();
                      // setOtpValues(defaultOTPObj);
                      handleResend();
                    }}
                  >
                    {loading ? "Please Wait..." : "Send OTP"}
                  </button>
                </div>
              </form>
            </div>
            <div className="terms-conditions">
              <p>
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
                <p className="mt-4">COPYRIGHT@2025, FIRE INSPECT</p>
              </p>
            </div>
          </div>
        </div>
      )}
      {step === "getUserClients" && (
        <div className="login-container d-flex justify-content-center">
          <div className="card login-card align-items-center">
            <div className="d-flex w-100 flex-column text-start mb-3 ">
              <h3 className="login-card-text fw-bold white-text  veryfyotp">Resident Management System</h3>
              <p className="login-card-text text mb-1">
                Hello, <strong style={{ color: "black" }}>{userEmail}</strong>.
                You are associated with below clients. Please choose one to
                continue.
              </p>
            </div>
            <div className="d-flex w-100 flex-column align-items-center gap-2">
              <div
                className="col-sm-12 mb-3 mobtop"
                style={{ height: "auto", overflowY: "scroll" }}
              >
                <div className="form-floating">
                  {loading ? (
                    <p className="text-start">Loading client data...</p>
                  ) : clientData && clientData.clients?.length > 0 ? (
                    clientData.clients.map((client, index) => (
                      <div
                        key={index}
                        className="p-2 mb-2 mt-2"
                        onClick={() =>
                            // window.open(`${client.subDomainURL}`, "_self")
                            {
                              // const sliced = client.subDomainURL.substring(client.subDomainURL.indexOf("/client"));
                              // window.history.replaceState(null, "", sliced);
                              // setStep("login");
                              // setClientSubdomain(client.subDomainURL)}
                              const slicedPath = client.subDomainURL.substring(
                                client.subDomainURL.indexOf("/client")
                              );
                              sessionStorage.setItem("userEmail", userEmail);
                              window.open(slicedPath, "_self");
                            }
                          }
                        style={{
                          border: "1px solid black",
                          borderRadius: "10px",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          cursor: "pointer",                          
                        }
                      
                      }
                      >
                        <p className="fs-6 mb-2 fw-semibold">
                          {client.clientName}
                        </p>

                        {/* <p
                          className="fs-6 mb-0 fw-semibold text-black"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            // window.open(`${client.subDomainURL}`, "_self")
                            {
                              // const sliced = client.subDomainURL.substring(client.subDomainURL.indexOf("/client"));
                              // window.history.replaceState(null, "", sliced);
                              // setStep("login");
                              // setClientSubdomain(client.subDomainURL)}
                              const slicedPath = client.subDomainURL.substring(
                                client.subDomainURL.indexOf("/client")
                              );
                              sessionStorage.setItem("userEmail", userEmail);
                              window.open(slicedPath, "_self");
                            }
                          }
                        >
                          {client.subDomainURL}
                        </p> */}

 <p
                          className="fs-6 mb-0 fw-semibold text-black"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            // window.open(`${client.subDomainURL}`, "_self")
                            {
                              // const sliced = client.subDomainURL.substring(client.subDomainURL.indexOf("/client"));
                              // window.history.replaceState(null, "", sliced);
                              // setStep("login");
                              // setClientSubdomain(client.subDomainURL)}
                              const slicedPath = client.subDomainURL.substring(
                                client.subDomainURL.indexOf("/client")
                              );
                              sessionStorage.setItem("userEmail", userEmail);
                              window.open(slicedPath, "_self");
                            }
                          }
                        >
                          {client.subDomainURL}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p>No client data found.</p>
                  )}
                  {/* </div> */}
                </div>
              </div>

              <div className="col-sm-12 mb-3 mt-2 flex-column gap-3 flex-sm-row text-end">
                <button
                  type="submit"
                  className="btnresend mb-3 w-100"
                  // style={{
                  //   textDecoration: "underline",
                  //   textUnderlinePosition: "under",
                  // }}
                  onClick={() => {
                    setStep("login");
                    setEmail("");
                    resetValue();
                  }}
                >
                  <div className="text-black text-end ">
                    <i className="fa fa-arrow-left  "></i> Back to Login
                  </div>
                </button>
              </div>
            </div>
            <div className="terms-conditions">
              <p className="mb-0">
                BY CONTINUING, YOU AGREE TO OUR{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  TERMS OF SERVICE
                </Link>{" "}
                AND{" "}
                <Link
                  to="/PrivacyPolicy"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  PRIVACY POLICY
                </Link>
              </p>
              <p className="mt-4 mb-0">COPYRIGHT@2025, FIRE INSPECT</p>
            </div>
          </div>
        </div>
      )}

      {/* <div className="footer-fixed">
        <p className="footertext mb-0">Powered By</p>
        <img src={footerLogo} alt="Acache Logo" className=" " />
      </div> */}
    </div>
  );
};

export default LogIn;
